<div class="filter-container">
    <div class="selectButton-col">
        <label class="title-label" for="selectButton">Date/Time Format</label>
        <div class="pbutton">
            <p-selectButton 
            class="buttonselect" 
            id="selectButton" 
            [allowEmpty]="false"
            [options]="timeFormatItems" 
            [(ngModel)]="formatSelection"/>
        </div>
    </div>
    <div class="switch-col">
        <div class="switch-row">
            <div>Sort Order</div>
            <div class="row">
                <button class="sort-button" (click)="onSortOrderClicked()">
                    {{sortOrder === 0 ? 'Ascending' : 'Descending'}}
                    <i class="sort-icon {{sortOrder === 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'}}"></i>
                </button>
            </div>

        </div>
        <div class="switch-row">
            <div class="row">
                <div class="flt-tag">FLT</div>
                <label for="flights-Label">Flights</label>
            </div>
            <p-inputSwitch [(ngModel)]="flights"></p-inputSwitch>
        </div>
        <div class="switch-row">
            <div class="row">
                <div class="flt-tag flt-dh">DH</div>
                <label for="deadhead-Label">Deadhead</label>
            </div>
            <p-inputSwitch [(ngModel)]="deadhead"></p-inputSwitch>
        </div>
        <div class="switch-row">
            <div class="row">
                <div class="flt-tag flt-cxl">CX</div>
                <label for="cancelled-Label">Cancelled</label>
            </div>
            <p-inputSwitch [(ngModel)]="cancelled"></p-inputSwitch>
        </div>
        <p class="footer">Sort Order and Date/Time Format are global settings.</p>
        <div class="error">
            <span [hidden]="flights === true || deadhead === true || cancelled === true">
                At least one filter item must be selected on.
            </span>
        </div>
    </div>
    <div class="button-container" *ngIf="appService.theme$ | async as theme">
        <button 
        pButton rRipple
        class="save-button" 
        type="button"
        (click)="onSave()"
        [disabled]="flights === false && deadhead === false && cancelled === false"
        [style]="{
            'background': theme === 'light' ? 'var(--button-primary)' : 'transparent',
            'color' : theme === 'light' ? 'var(--surface-0)' : 'var(--button-primary)'
            }">Save
            </button>
    </div>
</div>
